import { CumulativeAverageDurationResponseDto } from '../dto/top-apps/response/cumulative-avg-duration-response.dto';
import { CumulativeAverageDurationResult } from '../dto/top-apps/cube/mapped/cumulative-avg-duration-result.dto';
import {
  IWorkingDaysAnalyticsActivityV2Enum,
  IWorkingDaysAnalyticsActivityEnum,
} from '../enum/working-days-analytics-activity.enum';
import { ICumulativeAverageMapper } from '../interface/cumulative-average-mapper.interface';
import {
  CumulativeAverageDurationRaw,
  CumulativeAverageDurationV2Raw,
} from '../dto/top-apps/cube/raw/cumulative-average-duration.dto';

export class CumulativeAverageMapper implements ICumulativeAverageMapper {
  persistenceToDomain(
    model: CumulativeAverageDurationRaw
  ): CumulativeAverageDurationResult {
    return CumulativeAverageMapper.persistenceToDomain(model);
  }
  domainToRest(
    entity: CumulativeAverageDurationResult
  ): CumulativeAverageDurationResponseDto {
    return CumulativeAverageMapper.domainToRest(entity);
  }
  static persistenceToDomain(
    model: CumulativeAverageDurationRaw
  ): CumulativeAverageDurationResult {
    return {
      appId: String(model[IWorkingDaysAnalyticsActivityEnum.AppId]),
      totalDuration:
        Number(model[IWorkingDaysAnalyticsActivityEnum.TotalDuration]) || 0,
      count: Number(model[IWorkingDaysAnalyticsActivityEnum.count]) || 0,
      totalCallDuration: 0,
      callCount: 0,
      dayCount: Number(model[IWorkingDaysAnalyticsActivityEnum.DayCount]),
      weekCount: Number(model[IWorkingDaysAnalyticsActivityEnum.WeekCount]),
    };
  }
  static domainToRest(
    entity: CumulativeAverageDurationResult
  ): CumulativeAverageDurationResponseDto {
    throw new Error('not implemented');
  }
}

export class CumulativeAverageMapperV2 implements ICumulativeAverageMapper {
  persistenceToDomain(
    model: CumulativeAverageDurationV2Raw
  ): CumulativeAverageDurationResult {
    return CumulativeAverageMapperV2.persistenceToDomain(model);
  }
  domainToRest(
    entity: CumulativeAverageDurationResult
  ): CumulativeAverageDurationResponseDto {
    return CumulativeAverageMapperV2.domainToRest(entity);
  }
  static persistenceToDomain(
    model: CumulativeAverageDurationV2Raw
  ): CumulativeAverageDurationResult {
    return {
      appId: String(model[IWorkingDaysAnalyticsActivityV2Enum.AppId]),
      totalDuration:
        Number(model[IWorkingDaysAnalyticsActivityV2Enum.TotalDuration]) || 0,
      count: Number(model[IWorkingDaysAnalyticsActivityV2Enum.count]) || 0,
      totalCallDuration:
        Number(model[IWorkingDaysAnalyticsActivityV2Enum.TotalCallDuration]) ||
        0,
      callCount:
        Number(model[IWorkingDaysAnalyticsActivityV2Enum.CallCount]) || 0,
      dayCount: Number(model[IWorkingDaysAnalyticsActivityV2Enum.DayCount]),
      weekCount: Number(model[IWorkingDaysAnalyticsActivityV2Enum.WeekCount]),
    };
  }
  static domainToRest(
    entity: CumulativeAverageDurationResult
  ): CumulativeAverageDurationResponseDto {
    throw new Error('not implemented');
  }
}
